/**
 * Class description
 *
 * Created: 2018-05-08
 * @author jonas
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {BetLineEvent} from "@nolimitcity/slot-game/bin/core/betline/event/BetLineEvent";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {DungeonQuestLayerConfig} from "../../config/DungeonQuestLayerConfig";
import {DungeonQuestGameConfig} from "../DungeonQuestGameConfig";

export class DungeonQuestBetLines extends BaseView {
    private _layer:ScalableLayer;
    private _betLinesData:number[][];
    private _symSize:PIXI.Point;
    private _betLines:PIXI.DisplayObject[];
    private _offset:PIXI.Point;
    private _horizontalTexture:PIXI.Texture;
    private _diagonalTexture:PIXI.Texture;
    private _hasData:boolean;
    private _hasLoaded:boolean;

    constructor() {
        super();
        this._layer = StageManager.getLayer(DungeonQuestLayerConfig.BET_LINES.name);
        this._layer.addChild(this);
    }


    protected initAnimations():void {
        this._symSize = new PIXI.Point(DungeonQuestGameConfig.instance.SYMBOL_WIDTH, DungeonQuestGameConfig.instance.SYMBOL_HEIGHT);
        this._offset = new PIXI.Point(80, 60);
        this.createPartTextures();

        this._hasLoaded = true;
        this.tryToCreateLines();


    }

    protected addEventListeners():void {
        EventHandler.addEventListener(this, BetLineEvent.SHOW_WIN_BET_LINE, (event:GameEvent) => this.onShowWinBetLine(event.params[0]));
        EventHandler.addEventListener(this, BetLineEvent.HIDE_ALL_BET_LINES, (event:GameEvent) => this.onHideAllBetLines());
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
    }

    private onInitDataParsed(data:ParsedInitData):void {
        this._betLinesData = data.betLines;
        this._hasData = true;
        this.tryToCreateLines();
    }

    private onShowWinBetLine(betline:number) {
        this._betLines[betline].visible = true;
    }


    private onHideAllBetLines() {
        if(this._hasInit) {
            for(let line of this._betLines) {
                line.visible = false;
            }
        }
    }

    private tryToCreateLines() {
        if(this._hasLoaded && this._hasData) {
            this.createLines();
            //this.drawLines();
        }
    }

    private drawLines():void {
        if(this._betLinesData == undefined || this._symSize == undefined) {
            return;
        }

        const lines:PIXI.Graphics[] = [];

        for(let lineData of this._betLinesData) {
            const line = new PIXI.Graphics();

            line.lineStyle(6, 0xffffff, 0.3);
            line.moveTo(0, this._symSize.y * lineData[0]);
            line.lineTo(this._symSize.x, this._symSize.y * lineData[1]);
            line.lineTo(this._symSize.x * 2, this._symSize.y * lineData[2]);
            line.lineTo(this._symSize.x * 3, this._symSize.y * lineData[3]);
            line.lineTo(this._symSize.x * 4, this._symSize.y * lineData[4]);
            line.position.set(this._offset.x, this._offset.y);
            line.blendMode = PIXI.BLEND_MODES.ADD;
            line.visible = false;
            lines.push(line);

        }
        this._betLines = lines;

        for(let line of this._betLines) {
            this.addChild(line);
        }
    }

    private createLines() {
        this._betLines = [];
        for(let lineData of this._betLinesData) {
            const line = new PIXI.Container();

            for(let i:number = 1; i < lineData.length; i++) {
                const start:number = lineData[i - 1];
                const end:number = lineData[i];
                const direction = (end - start);
                const texture:PIXI.Texture = direction == 0 ? this._horizontalTexture : this._diagonalTexture;
                const part:PIXI.Sprite = new PIXI.Sprite(texture);
                part.anchor.set(0, 0.5);
                part.rotation = 0.70862113 * direction;
                part.position.set(this._symSize.x * (i - 1), this._symSize.y * start);

                line.addChild(part);

            }


            line.position.set(this._offset.x, this._offset.y);
            line.visible = false;
            this._betLines.push(line)
        }

        for(let line of this._betLines) {
            this.addChild(line);
        }

    }

    private createPartTextures() {
        this._horizontalTexture = this.createTexture(this._symSize.x);
        this._diagonalTexture = this.createTexture(Math.sqrt(this._symSize.x * this._symSize.x + this._symSize.y * this._symSize.y));
    }

    private createTexture(length:number, thickness:number = 6):PIXI.Texture {
        const line = new PIXI.Graphics();
        line.lineStyle(thickness, 0xffffff, 0.3);
        line.moveTo(0, thickness);
        line.lineTo(length, thickness);

        const renderTexture:PIXI.RenderTexture = PIXI.RenderTexture.create({width : length, height : thickness * 2});
        StageManager.renderer.render(line, renderTexture);

        return renderTexture;

    }


}